import React from 'react';
import {DashboardCard} from './new_dashboard/components/DashboardCard';
import {FileWaveform} from './file_waveform';
import {AudioSeekBar} from './AudioSeekBar';
import {PlayIcon} from '@/modules/audio_player/audio_player_module';
import {DBObjects} from '@/store/store_types';
import {useIsMobile} from '@/utils/user_agent';

type WaveformData = {
    duration: number | undefined;
    waveform_data: number[][] | undefined;
} | null;

type Props = {
    fileInfo: DBObjects['File'];
    title?: React.ReactNode;
    centered?: boolean;
    waveformData?: WaveformData;
    isLoadingWaveform?: boolean;
};

export const WaveformCard = ({fileInfo, title, centered = true, waveformData, isLoadingWaveform}: Props) => {
    const isMobile = useIsMobile();

    const content = (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            alignItems: centered ? 'center' : 'stretch',
            position: 'relative',
            padding: centered ? '1rem' : '0'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: centered ? 'center' : 'flex-start',
                width: '100%'
            }}>
                <FileWaveform
                    fileInfo={fileInfo}
                    waveformData={waveformData}
                    isLoadingWaveform={isLoadingWaveform}
                    style={{
                        maxWidth: centered ? '800px' : '100%',
                        width: '100%'
                    }}
                />
            </div>
            {isMobile && (
                <div style={{
                    maxWidth: centered ? '800px' : '100%',
                    width: '100%'
                }}>
                    <AudioSeekBar showTimeLabels={false} fileInfo={fileInfo} />
                </div>
            )}
        </div>
    );

    if (!title) {
        return content;
    }

    return (
        <DashboardCard
            title={title}
            icon={<PlayIcon fileInfo={fileInfo} />}
            noPadding
        >
            {content}
        </DashboardCard>
    );
};
